"use client";

import React from "react";
import { Compass, MapPin, CircleCheck as CheckCircle2, ArrowRight } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const phasesData = [{
  step: "Phase 1",
  title: "Avant le départ",
  icon: Compass,
  description: "De la décision à la clôture de la vie quotidienne en France\xA0: repérage, logement, emploi, démarches administratives. Tout ce qui se prépare avant de partir.",
  highlights: ["Décision, repérage & budget prévisionnel", "Recherche d'emploi & marché suédois", "Trouver son premier logement à distance", "Clôture administrative en France"]
}, {
  step: "Inclus dans le guide complet + Tracker budget et organisation",
  title: "En Suède",
  icon: MapPin,
  description: "De l'arrivée à l'installation : personnummer, école, banque, vie quotidienne, et tout le lexique qu'on finit par apprendre sur le tas.",
  highlights: ["Obtenir le personnummer & le BankID", "Ouverture de compte bancaire & assurances", "Système scolaire, crèches & garderies", "Lexique essentiel & codes du quotidien"]
}];
export default function GuidePhases() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section id="guidephases" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <Badge variant="outline" className="mb-4 border-secondary/30 text-secondary font-medium tracking-wide uppercase text-xs px-3 py-1 rounded-full">
            Structure & organisation
          </Badge>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif tracking-tight text-foreground font-normal">
            Ce que contient le guide
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground/80 font-sans">Une feuille de route concrète divisée en deux étapes clés pour aborder ce changement vie un peu plus sereinement !</p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {phasesData.map((phase, index) => {
          const Icon = phase.icon;
          return <motion.div key={phase.step} data-index={index} variants={cardVariants} className="h-full">
                <Card className="h-full border border-border/80 bg-muted/40 hover:bg-muted/70 transition-[background-color,border-color,box-shadow] duration-300 rounded-2xl p-6 sm:p-8 flex flex-col justify-between shadow-xs">
                  <div>
                    <CardHeader className="p-0 mb-6 flex flex-row items-start justify-between gap-4">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl bg-secondary/15 text-secondary flex items-center justify-center shrink-0">
                          <Icon className="size-6" />
                        </div>
                        <div>
                          <span className="text-xs font-mono uppercase tracking-wider text-secondary font-semibold block">
                            {phase.step}
                          </span>
                          <CardTitle className="text-2xl font-serif font-medium text-foreground mt-0.5">
                            {phase.title}
                          </CardTitle>
                        </div>
                      </div>
                      <Badge variant="secondary" className="bg-secondary text-secondary-foreground text-xs font-normal rounded-full px-2.5 py-0.5">
                        Étape {index + 1}
                      </Badge>
                    </CardHeader>

                    <CardContent className="p-0">
                      <p className="text-foreground/90 font-sans leading-relaxed text-base mb-6">
                        {phase.description}
                      </p>

                      <div className="pt-4 border-t border-border/60">
                        <span className="text-xs font-medium uppercase tracking-wider text-foreground/70 block mb-3 font-mono">
                          Points traités
                        </span>
                        <ul className="space-y-2.5">
                          {phase.highlights.map((point, pointIndex) => <li key={pointIndex} data-index={pointIndex} className="flex items-start gap-2.5 text-sm text-foreground/80 font-sans">
                              <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                              <span>{point}</span>
                            </li>)}
                        </ul>
                      </div>
                    </CardContent>
                  </div>

                  <div className="mt-8 pt-4 flex items-center gap-2 text-sm font-medium text-secondary">
                    <span>Inclus dans le guide complet</span>
                    
                  </div>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}